import script from "./NotasView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotasView.vue?vue&type=script&setup=true&lang=js"

import "./NotasView.vue?vue&type=style&index=0&id=a3295f7c&lang=css"

const __exports__ = script;

export default __exports__